import { render, staticRenderFns } from "./TranProgramProgramModuleUpdate.vue?vue&type=template&id=17e5b58c&scoped=true"
import script from "./TranProgramProgramModuleUpdate.vue?vue&type=script&lang=js"
export * from "./TranProgramProgramModuleUpdate.vue?vue&type=script&lang=js"
import style0 from "./TranProgramProgramModuleUpdate.vue?vue&type=style&index=0&id=17e5b58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e5b58c",
  null
  
)

export default component.exports